import {
  SEARCH_DEFAULTS,
  SEARCH_PATHS,
  SEARCH_SORT_OPTIONS,
} from '../constants/search'

export function buildSearchPath(params: {
  q?: string
  sort?: string
  page?: number
}): string {
  const search = new URLSearchParams()
  const query = params.q?.trim()
  if (query) search.set('q', query)

  if (params.sort && params.sort !== SEARCH_DEFAULTS.sortKey) {
    search.set('sort', params.sort)
  }

  if (params.page != null && params.page > SEARCH_DEFAULTS.page) {
    search.set('page', String(params.page))
  }

  const qs = search.toString()
  return qs ? `${SEARCH_PATHS.page}?${qs}` : SEARCH_PATHS.page
}

export function resolveSearchSort(
  sortKey: string | null | undefined,
): (typeof SEARCH_SORT_OPTIONS)[number] {
  const match = SEARCH_SORT_OPTIONS.find((option) => option.key === sortKey)
  return match ?? SEARCH_SORT_OPTIONS[0]
}
